import { getCellType } from '@/common/utils/home/get-cell-type'
import { getTitle } from '@/common/utils/home/get-title'
import { convertMultiSectionEventList } from '@/common/converter/convert-event-list'

/**
 * convert to MultiSectionList (v1) item format
 * 카탈로그 데이터(신) 를 받아 멀티섹션 리스트(구) 로 변환
 * @param catalog
 * @returns {{note: string, bg_color: string, eventlist: Array, icon: string, whitelist: string, force_refresh: string, cell_type: (string|*), title: string, bg_image: string}}
 */
export const convertMultiSectionInfo = (catalog) => {
  const { description = '', refresh = '', elementList = [] } = catalog
  return {
    note: description,
    force_refresh: refresh,
    cell_type: getCellType(elementList),
    bg_color: '',
    bg_image: '',
    icon: '',
    title: getTitle(elementList),
    whitelist: '',
    eventlist: convertMultiSectionEventList(elementList),
  }
}
